import { render, staticRenderFns } from "./FormFilterUpcomingReleases.vue?vue&type=template&id=b604c784"
import script from "./FormFilterUpcomingReleases.vue?vue&type=script&lang=js"
export * from "./FormFilterUpcomingReleases.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports